import { FC, lazy, LazyExoticComponent, SVGProps } from 'react';

export type DesignSystemIconComponent = FC<SVGProps<SVGSVGElement>>;

type DesignSystemIconModule = {
  ReactComponent: DesignSystemIconComponent;
};

export const designSystemIconNames = [
  'alert-circle/16',
  'alert-circle/24',
  'bullet/16',
  'bullet/24',
  'burger-menu/16',
  'burger-menu/24',
  'checkmark-circle/16',
  'checkmark-circle/24',
  'credit-card/16',
  'credit-card/24',
  'drag-drop-horizontal/16',
  'drag-drop-horizontal/24',
  'drag-drop-vertical/16',
  'drag-drop-vertical/24',
  'files/file-download/16',
  'files/file-download/24',
  'files/file-import/16',
  'files/file-import/24',
  'files/file-script/16',
  'files/file-script/24',
  'files/pdf/16',
  'files/pdf/24',
  'files/text-file/16',
  'files/text-file/24',
  'general/ai-detector/16',
  'general/ai-detector/24',
  'general/ai-search/16',
  'general/ai-search/24',
  'general/ai/16',
  'general/ai/24',
  'general/arrow-turn-forward/16',
  'general/arrow-turn-forward/24',
  'general/brush/16',
  'general/brush/24',
  'general/bubble-chat/16',
  'general/bubble-chat/24',
  'general/calendar/16',
  'general/calendar/24',
  'general/check-double/16',
  'general/check-double/24',
  'general/check-list/16',
  'general/check-list/24',
  'general/check/16',
  'general/check/24',
  'general/chrome/16',
  'general/chrome/24',
  'general/citation/16',
  'general/citation/24',
  'general/copy/16',
  'general/copy/24',
  'general/delete/16',
  'general/delete/24',
  'general/download/16',
  'general/download/24',
  'general/edit/16',
  'general/edit/24',
  'general/filter/16',
  'general/filter/24',
  'general/flashcards/16',
  'general/flashcards/24',
  'general/help-circle/16',
  'general/help-circle/24',
  'general/highlight/16',
  'general/highlight/24',
  'general/history/16',
  'general/history/24',
  'general/home/16',
  'general/home/24',
  'general/humanize/16',
  'general/humanize/24',
  'general/idea/16',
  'general/idea/24',
  'general/image/16',
  'general/image/24',
  'general/information-circle/16',
  'general/information-circle/24',
  'general/learn/16',
  'general/learn/24',
  'general/link/16',
  'general/link/24',
  'general/lock/16',
  'general/lock/24',
  'general/note-edit/16',
  'general/note-edit/24',
  'general/paperclip/16',
  'general/paperclip/24',
  'general/personal info/16',
  'general/personal info/24',
  'general/placeholder/16',
  'general/placeholder/24',
  'general/plagiarism/16',
  'general/plagiarism/24',
  'general/plus-circle/16',
  'general/plus-circle/24',
  'general/plus-sign/16',
  'general/plus-sign/24',
  'general/profile/16',
  'general/profile/24',
  'general/quill-write/16',
  'general/quill-write/24',
  'general/quiz/16',
  'general/quiz/24',
  'general/references/16',
  'general/references/24',
  'general/refresh/16',
  'general/refresh/24',
  'general/reprism-chat/16',
  'general/reprism-chat/24',
  'general/search/16',
  'general/search/24',
  'general/send-arrow-up/16',
  'general/send-arrow-up/24',
  'general/settings/16',
  'general/settings/24',
  'general/spinner-loader/16',
  'general/spinner-loader/24',
  'general/summary/16',
  'general/summary/24',
  'general/text/16',
  'general/text/24',
  'general/thumbs-down-filled/16',
  'general/thumbs-down/16',
  'general/thumbs-down/24',
  'general/thumbs-up-filled/16',
  'general/thumbs-up/16',
  'general/thumbs-up/24',
  'general/tokens/16',
  'general/tokens/24',
  'general/undo/16',
  'general/undo/24',
  'general/unlock/16',
  'general/unlock/24',
  'general/upgrade/16',
  'general/upgrade/24',
  'general/upload/16',
  'general/upload/24',
  'general/verified/16',
  'general/verified/24',
  'general/view-off/16',
  'general/view-off/24',
  'general/view/16',
  'general/view/24',
  'general/word-count/16',
  'general/word-count/24',
  'general/write/16',
  'general/write/24',
  'globe/16',
  'globe/24',
  'image-caption/16',
  'image-caption/24',
  'link-square/16',
  'link-square/24',
  'navigation/arrow-down/16',
  'navigation/arrow-down/24',
  'navigation/arrow-left/16',
  'navigation/arrow-left/24',
  'navigation/arrow-right/16',
  'navigation/arrow-right/24',
  'navigation/arrow-up-left/16',
  'navigation/arrow-up-left/24',
  'navigation/arrow-up-right/16',
  'navigation/arrow-up-right/24',
  'navigation/arrow-up/16',
  'navigation/arrow-up/24',
  'navigation/chevron-down/16',
  'navigation/chevron-down/24',
  'navigation/chevron-left/16',
  'navigation/chevron-left/24',
  'navigation/chevron-right/16',
  'navigation/chevron-right/24',
  'navigation/chevron-up/16',
  'navigation/chevron-up/24',
  'navigation/chevrons-left/16',
  'navigation/chevrons-left/24',
  'navigation/chevrons-right/16',
  'navigation/chevrons-right/24',
  'navigation/close/16',
  'navigation/close/24',
  'navigation/left-panel/16',
  'navigation/left-panel/24',
  'navigation/log-in/16',
  'navigation/log-in/24',
  'navigation/log-out/16',
  'navigation/log-out/24',
  'navigation/maximize/16',
  'navigation/maximize/24',
  'navigation/minimize/16',
  'navigation/minimize/24',
  'navigation/more-horizontal_oval/16',
  'navigation/more-horizontal_oval/24',
  'navigation/more-horizontal/16',
  'navigation/more-horizontal/24',
  'rephrase/16',
  'rephrase/24',
  'star-filled/16',
  'star-filled/24',
  'star/16',
  'star/24',
  'stop/16',
  'stop/24',
  'table-header/16',
  'table-header/24',
  'text-editor/bold/16',
  'text-editor/bold/24',
  'text-editor/bullet-list/16',
  'text-editor/bullet-list/24',
  'text-editor/equation/16',
  'text-editor/equation/24',
  'text-editor/h1/16',
  'text-editor/h1/24',
  'text-editor/h2/16',
  'text-editor/h2/24',
  'text-editor/h3/16',
  'text-editor/h3/24',
  'text-editor/h4/16',
  'text-editor/h4/24',
  'text-editor/h5/16',
  'text-editor/h5/24',
  'text-editor/italic/16',
  'text-editor/italic/24',
  'text-editor/numbered-list/16',
  'text-editor/numbered-list/24',
  'text-editor/table/16',
  'text-editor/table/24',
  'text-editor/text/16',
  'text-editor/text/24',
  'text-editor/underline/16',
  'text-editor/underline/24',
] as const;

export type DesignSystemIconName = (typeof designSystemIconNames)[number];

type DesignSystemIconLoader = () => Promise<{
  default: DesignSystemIconComponent;
}>;

const loadDesignSystemIcon = (
  name: DesignSystemIconName,
): Promise<{ default: DesignSystemIconComponent }> => {
  return import(
    /* webpackChunkName: "design-system-icon-[request]" */
    /* webpackMode: "lazy" */
    `./assets/${name}.svg`
  ).then((module) => ({
    default: (module as DesignSystemIconModule).ReactComponent,
  }));
};

export const designSystemIconMap = Object.fromEntries(
  designSystemIconNames.map((name) => [
    name,
    (): Promise<{ default: DesignSystemIconComponent }> =>
      loadDesignSystemIcon(name),
  ]),
) as Record<DesignSystemIconName, DesignSystemIconLoader>;

const loadedIconComponentByName = new Map<
  DesignSystemIconName,
  LazyExoticComponent<DesignSystemIconComponent>
>();

export const getDesignSystemIconComponent = (
  name: DesignSystemIconName,
): LazyExoticComponent<DesignSystemIconComponent> => {
  const loadedComponent = loadedIconComponentByName.get(name);

  if (loadedComponent) {
    return loadedComponent;
  }

  const lazyComponent = lazy(designSystemIconMap[name]);
  loadedIconComponentByName.set(name, lazyComponent);

  return lazyComponent;
};
